namespace Matrix.Dashboards {
    export class ChartSeriesColumns {
        static columnsKey = 'Matrix.Dashboards.ChartSeriesColumns';
    }
}
